import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChartData, ChartDataset, ChartOptions, ChartType, ChartTypeRegistry, TooltipItem, TooltipModel } from 'chart.js';
import { DateTime } from 'luxon';
import { NgxUiLoaderConfig, NgxUiLoaderService } from 'ngx-ui-loader';
import { ReplaySubject, concat, map, startWith } from 'rxjs';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { ExcelService } from 'src/app/services/excel.service';
import { KpiService } from 'src/app/services/kpi.service';

@Component({
  selector: 'app-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss'],
  standalone: false // NOSONAR
})

export class KpiComponent implements OnInit {
  selectedCities: any[];
  selectedEventBar: any[] = [];
  selectedDomicileBar: any = { label: '01TMK', value: 'TMMK' };
  selectedEventPie: any[] = [];
  selectedDomicilePie: any = { label: '01TMK', value: 'TMMK' };
  selectedEventLine: any[] = [];
  selectedDomicileLine: any = { label: '01TMK', value: 'TMMK' };
  successMessage: any;
  errorMessage: any;
  event: any;
  dropdownOptionDomicileBar: { label: string; value: string }[] = [];
  dropdownOptionEventTypesBar: any[];
  dropdownDomicilePie: { label: string; value: string }[] = [];
  dropdownEventTypesPie: any[];
  dropdownDomicileLine: { label: string; value: string }[] = [];
  dropdownEventTypesLine: any[];
  datalist: any;
  pieData: any;
  lineData: any;
  startDatePie: string;
  endDatePie: string;
  startDateBar: string;
  endDateBar: string;
  startDateLine: string;
  endDateLine: string;
  selectedSpan: string = 'Daily';
  timespanlist = [];
  showMessage: any;
  excelData: any;
  maxValueBar: number;
  const_year_format = 'yyyy-MM-dd'
  maxDate = DateTime.fromJSDate(new Date()).toFormat(this.const_year_format);
  maxMonth = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM');
  loaderId = 'bar';
  requiredMsg = '';
  requiredMsg1: string;
  requiredMsg2: string;
  showMessage1: string;
  showMessage2: string;
  errorMessage1: string;
  errorMessage2: string;
  endMonthLine: string;
  startMonthLine: string;
  eventFilterCtrl: FormControl = new FormControl();
  filteredEvent: ReplaySubject<any[]> = new ReplaySubject(1);
  eventPieFilterCtrl: FormControl = new FormControl(); const_date = 'MM/dd/yyyy'
  filteredEventPie: ReplaySubject<any[]> = new ReplaySubject(1); const_msg2 = 'End date can not be less than or equal to start Date'
  eventLineFilterCtrl: FormControl = new FormControl(); const_msg1 = 'Please click on export button for given criteria'
  filteredEventLine: ReplaySubject<any[]> = new ReplaySubject(1); const_nodata = 'No data is present for selected criteria.'
  constructor(
    private readonly kpiService: KpiService,
    private readonly datePipe: DatePipe,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly excelService: ExcelService
  ) {
    this.endDatePie = this.datePipe.transform(new Date(), this.const_year_format);
    let today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDatePie = this.datePipe.transform(today, this.const_year_format);

    this.endDateBar = this.datePipe.transform(new Date(), this.const_year_format);
    today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDateBar = this.datePipe.transform(today, this.const_year_format);

    this.endDateLine = this.datePipe.transform(new Date(), this.const_year_format);
    today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDateLine = this.datePipe.transform(today, this.const_year_format);

    this.endMonthLine = this.datePipe.transform(new Date(), 'yyyy-MM');
    const currentMonth = DateTime.now().minus({ month: 1 });
    this.startMonthLine = currentMonth.toFormat('yyyy-MM');
  }

  ngOnInit(): void {
    this.filterApiCall();
    this.eventFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionEventTypesBar) : this.dropdownOptionEventTypesBar?.slice())
      )
      .subscribe(filtered => {
        this.filteredEvent.next(filtered);
      });
    this.eventPieFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownEventTypesPie) : this.dropdownEventTypesPie?.slice())
      )
      .subscribe(filtered => {
        this.filteredEventPie.next(filtered);
      });
    this.eventLineFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownEventTypesLine) : this.dropdownEventTypesLine?.slice())
      )
      .subscribe(filtered => {
        this.filteredEventLine.next(filtered);
      });
  }
  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return list.filter(d => d.value.toLowerCase().includes(filterValue));
  }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length; // NOSONAR
  }

  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }


  toggleSelectAll(event: any, list: any[]): any[] {
    return event.checked ? [...list] : [];
  }
  public barChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true, //  Controls legend visibility
        position: 'bottom', //  Sets position
      },
    },
  };


  //code for BarChart
  setChartOptions(maxValue) {
    this.barChartOptions = {
      responsive: true,
      indexAxis: 'y', //  Makes the bar chart horizontal
      scales: {
        x: {
          beginAtZero: true,
          max: maxValue,
          ticks: {
            stepSize: 1,
            font: {
              size: 15,
            },
          },
        },
        y: {
          ticks: {
            font: {
              size: 15,
            },
          },
        },
      },
    };

  }

  public barChartData: ChartData<'bar', number[], string[]> = {
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        barThickness: 15,
      },
    ],
  };
  barChartLabels = [];

  public barChartType: ChartType = 'bar'; // Replace "horizontalBar" with "bar  barChartLegend = false;

  chartClicked(e: any): void { console.info(e) }
  chartHovered(e: any): void { console.info(e) }
  const_event = 'Event Type'; const_start_date = 'Start Date'
  headers = [
    this.const_start_date,
    'End Date',
    'Domicile',
    this.const_event,
    'Count',
  ];

  onBtExport() {
    const exportData = [];
    this.kpiService.getBarExcel(
      this.dropdownOptionEventTypesBar,
      this.dropdownOptionDomicileBar,
      this.datePipe.transform(this.startDateBar, this.const_date),
      this.datePipe.transform(this.endDateBar, this.const_date)
    ).subscribe((res) => {

      this.excelData = res;
      this.excelData.forEach(e => {
        const obj = {
          Start_date: this.datePipe.transform(this.startDateBar, this.const_date),
          End_Date: this.datePipe.transform(this.endDateBar, this.const_date),
          Domicile: e.plantId,
          EventType: e.eventType,
          Count: e.count,
        };

        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'getBarGraphData', this.headers);
    });
  }

  onBtExport1() {
    const headers1 = [
      this.const_start_date,
      'End Date',
      'Domicile',
      this.const_event,
      'Count',
      'Percentage'
    ];
    const exportData = [];
    this.kpiService.getPieExcel(
      this.dropdownOptionEventTypesBar,
      this.dropdownOptionDomicileBar,
      this.datePipe.transform(this.startDatePie, this.const_date),
      this.datePipe.transform(this.endDatePie, this.const_date)
    ).subscribe((res) => {

      this.excelData = res;
      this.excelData.forEach(e => {
        const obj = {
          Start_date: this.datePipe.transform(this.startDatePie, this.const_date),
          End_Date: this.datePipe.transform(this.endDatePie, this.const_date),
          Domicile: e.plantId,
          EventType: e.eventType,
          Count: e.eventCount,
          Percentage: Math.round(e.percentage * 100) / 100,
        };

        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'getPieGraphData', headers1);
    });
  }

  onBtExport2() {
    const headers1 = [
      this.const_start_date,
      'End Date',
      'TimePeriod',
      'Domicile',
      this.const_event,
      'Count',
    ];
    const exportData = [];
    this.kpiService.getLineExcel(
      this.dropdownOptionEventTypesBar,
      this.dropdownOptionDomicileBar,
      this.datePipe.transform(this.startDateLine, this.const_date),
      this.datePipe.transform(this.endDateLine, this.const_date),
      this.selectedSpan
    ).subscribe((res) => {

      this.excelData = res;
      this.excelData.forEach(e => {
        const obj = {
          Start_date: this.datePipe.transform(this.startDateLine, this.const_date),
          End_Date: this.datePipe.transform(this.endDateLine, this.const_date),
          TimePriod: e.timePeriod,
          Domicile: e.plantId,
          EventType: e.eventType,
          Count: e.count,
        };

        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'getLineGraphData', headers1);
    });
  }

  //code for pieChart

  chartLabels = [
    'Red',
    'Blue',
    'Yellow',
    'White',
    'Pink',
    'Orange',
    'Green',
    'Other',
  ];
  chartData = {
    labels: [...this.chartLabels], //  Ensure this is an array of strings
    datasets: [
      {
        data: [30, 50, 20, 10, 35, 40, 55, 60],
      },
    ],
  };

  public pieChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true
        },
      },
      tooltip: {
        enabled: true,
        mode: 'nearest',
        bodyFont: {
          size: 18, //  Increase tooltip body font size
        },
        callbacks: {
          label: function (this: TooltipModel<keyof ChartTypeRegistry>, tooltipItem: TooltipItem<keyof ChartTypeRegistry>) {
            const dataset = tooltipItem.chart.data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.dataIndex];
            return `${tooltipItem.label}: ${value} %`;
          },
        },
      },
    },
  };

  //Code for Line Chart
  public lineChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          padding: 10,
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 40,
          minRotation: 0,
          color: 'rgba(0,0,0,1)', //  Use color instead of fontColor
          font: {
            size: 15, //  Use font.size instead of fontSize
          },
        },
        grid: {
          drawOnChartArea: true, //  Use grid instead of gridLines
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          font: {
            size: 15, //  Use font.size instead of fontSize
          },
        },
      },
    },
  };


  public lineChartType: ChartType = 'line';

  lineChartLabels = []; //timeperiod

  lineChartData: ChartDataset[] = [];

  borderColors = [
    'rgb(75, 192, 192)',
    'rgb(255,153,51)',
    'rgb(153, 255, 153)',
    'rgb(255, 0, 127)',
    'rgb(255, 204, 229)',
    'rgb(255,255,102)',
    'rgb(188,199,202)',
    'rgb(191, 0, 255)',
  ];

  openPie() {
    this.onPieClicked();
  }
  openBar() {
    this.onBarClicked();
  }
  openLine() {
    this.timespanlist = ['Daily', 'Weekly', 'Monthly', 'Yearly'];
    this.onLineClicked();
  }
  resetPie() {
    this.endDatePie = this.datePipe.transform(new Date(), this.const_year_format);
    const today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDatePie = this.datePipe.transform(today, this.const_year_format);
    this.selectedDomicilePie = { label: '01TMK', value: 'TMMK' };
    this.selectedEventPie = this.dropdownEventTypesPie;
    this.onPieClicked();
  }
  resetBar() {
    this.endDateBar = this.datePipe.transform(new Date(), this.const_year_format);
    const today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDateBar = this.datePipe.transform(today, this.const_year_format);
    this.selectedDomicileBar = { label: '01TMK', value: 'TMMK' };
    this.selectedEventBar = this.dropdownOptionEventTypesBar;

    //Bar API CALL
    this.onBarClicked();
  }
  resetLine() {
    this.endDateLine = this.datePipe.transform(new Date(), this.const_year_format);
    const today = new Date();
    today.setDate(today.getDate() - 30);
    this.startDateLine = this.datePipe.transform(today, this.const_year_format);
    this.selectedDomicileLine = { label: '01TMK', value: 'TMMK' };
    this.selectedEventLine = this.dropdownEventTypesLine;
    this.selectedSpan = 'Daily';

    //Line API CALL
    this.onLineClicked();
  }

  getDateDiff(startDate, endDate) {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);

    const Time = eDate.getTime() - sDate.getTime();
    return Time / (1000 * 3600 * 24);
  }

  filterApiCall() {
    this.kpiService.getFilter()?.subscribe((res) => {
      if (res) {
        this.event = res;
        if (this.event.domicile && this.event.domicile.length > 0) {
          this.event.domicile.sort((a, b) => {
            const descA = a.itemDesc?.toLowerCase() ?? '';
            const descB = b.itemDesc?.toLowerCase() ?? '';

            if (descA < descB) {return -1;}
            if (descA > descB) {return 1;}
            return 0;
          });

          this.dropdownOptionDomicileBar = [];
          this.dropdownDomicilePie = [];
          this.dropdownDomicileLine = [];
          this.event.domicile.forEach((obj, _index) => {
            if (!obj.itemDesc.includes('PDC')) {
              this.dropdownOptionDomicileBar.push({
                label: obj.itemCode,
                value: obj.itemDesc,
              });
              console.info(this.dropdownOptionDomicileBar)
              this.dropdownDomicilePie.push({
                label: obj.itemCode,
                value: obj.itemDesc,
              });
              this.dropdownDomicileLine.push({
                label: obj.itemCode,
                value: obj.itemDesc,
              });
            }
          });
          this.selectedDomicileBar = this.dropdownOptionDomicileBar.find(
            option => option.value == 'TMMK' // NOSONAR
          );
        }

        if (this.event.eventPrbTypes && this.event.eventPrbTypes.length > 0) {
          this.dropdownOptionEventTypesBar = [];
          this.dropdownEventTypesPie = [];
          this.dropdownEventTypesLine = [];
          this.event.eventPrbTypes.forEach((obj, _index) => {
            this.dropdownOptionEventTypesBar.push({
              label: obj.eventTypeId,
              value: obj.eventType,
            });
            this.filteredEvent.next(this.dropdownOptionEventTypesBar?.slice());

            this.dropdownEventTypesPie.push({
              label: obj.eventTypeId,
              value: obj.eventType,
            });
            this.filteredEventPie.next(this.dropdownEventTypesPie?.slice());

            this.dropdownEventTypesLine.push({
              label: obj.eventTypeId,
              value: obj.eventType,
            });
            this.filteredEventLine.next(this.dropdownEventTypesLine?.slice());

          });

          this.selectedEventBar = this.dropdownOptionEventTypesBar;
          this.selectedEventPie = this.dropdownEventTypesPie;
          this.selectedEventLine = this.dropdownEventTypesLine;

          this.dropdownOptionEventTypesBar.forEach((element) => {
            this.barChartLabels.push(element.value);
          });
          this.selectedDomicilePie = this.dropdownDomicilePie.find(
            option => option.value == 'TMMK' // NOSONAR
          );
          this.selectedDomicileLine = this.dropdownDomicileLine.find(
            option => option.value == 'TMMK' // NOSONAR
          );
        }

      }
    });
  }

  onPieClicked() {
    if (this.getDateDiff(this.startDatePie, this.endDatePie) <= 0) {
      this.errorMessage1 = this.const_msg2
    }
    else if (this.selectedEventPie.length == 0) { // NOSONAR
      this.chartData = {
        labels: [],
        datasets: [
          {
            data: [],
          },
        ],
      };
      this.chartLabels = [];
      this.showMessage2 = '';
      this.requiredMsg1 = 'Required*'
    }
    else if (this.getDateDiff(this.startDatePie, this.endDatePie) > 365) {
      this.requiredMsg1 = '';
      this.chartData = {
        labels: [],
        datasets: [
          {
            data: [],
          },
        ],
      };
      this.chartLabels = [];
      this.showMessage2 = this.const_msg1
    }
    else {
      this.requiredMsg1 = '';
      const label = [];
      const dataArr = [];
      this.ngxUiLoaderService.startLoader('loader-03');
      this.kpiService
        .getPieGraph(
          this.selectedEventPie,
          this.selectedDomicilePie.label,
          this.datePipe.transform(this.startDatePie, this.const_date),
          this.datePipe.transform(this.endDatePie, this.const_date)
        )
        ?.subscribe((res) => {
          this.ngxUiLoaderService.stopLoader('loader-03');
          this.showMessage2 = null;
          this.pieData = res;
          if (this.pieData.length == 0) { // NOSONAR
            this.showMessage2 = this.const_nodata;
          }
          if (res) {
            this.pieData.forEach((element) => {
              element.percentage = Math.round(element.percentage * 100) / 100;
              label.push(element.eventType);
              dataArr.push(element.percentage);
            });
            this.chartLabels = label;
            this.chartData = {
              labels: label,
              datasets: [
                {
                  data: dataArr,
                },
              ],
            };
          }
        });
    }


  }

  onBarClicked() {

    if (this.getDateDiff(this.startDateBar, this.endDateBar) <= 0) {
      this.errorMessage = this.const_msg2
    }
    else if (this.selectedEventBar.length == 0) { // NOSONAR
      this.barChartLabels = [];
      this.showMessage1 = '';
      this.requiredMsg = 'Required*'
    }
    else if (this.getDateDiff(this.startDateBar, this.endDateBar) > 365) {
      this.requiredMsg = '';
      this.barChartLabels = [];
      this.showMessage1 = this.const_msg1
    }
    else {
      this.barChartLabels = [];
      this.requiredMsg = '';
      this.barChartData = {
        labels: [],
        datasets: [
          {
            label: this.selectedDomicileBar?.label,
            data: [],
            barThickness: 15,
          },
        ],
      };

      this.ngxUiLoaderService.startLoader('loader-02');
      this.kpiService
        .getBarGraph(
          this.selectedEventBar,
          this.selectedDomicileBar?.label,
          this.datePipe.transform(this.startDateBar, this.const_date),
          this.datePipe.transform(this.endDateBar, this.const_date)
        )
        ?.subscribe((res) => {
          this.ngxUiLoaderService.stopLoader('loader-02');
          const response = JSON.parse(JSON.stringify(res));
          this.datalist = response.filter(item => item.plantId == this.selectedDomicileBar.label); // NOSONAR
          if (this.datalist.length == 0) { // NOSONAR
            this.showMessage1 = this.const_nodata;
          }

          this.datalist.forEach((element) => {
            this.barChartData.labels.push(element.eventType);
            this.barChartData.datasets[0].data.push(element.count);
          });
          const dataArray = this.barChartData?.datasets?.[0]?.data as number[] || [];
          this.maxValueBar = Math.max(...dataArray);
          this.maxValueBar += 10;
          console.info(this.maxValueBar)
          this.setChartOptions(this.maxValueBar);
        });
    }

  }

  onLineClicked() {
    if (this.selectedSpan == 'Monthly') { // NOSONAR
      this.startDateLine = this.startMonthLine + "-01";
      this.endDateLine = DateTime.fromFormat(this.endMonthLine, "yyyy-MM").endOf('month').toFormat(this.const_year_format);
    }
    if (this.getDateDiff(this.startDateLine, this.endDateLine) <= 0) {
      this.errorMessage2 = this.const_msg2
    }
    else if (this.selectedEventLine.length == 0) { // NOSONAR
      this.lineChartData = [];
      this.lineChartLabels = [];
      this.showMessage = null;
      this.requiredMsg2 = 'Required*'
    } else if (this.getDateDiff(this.startDateLine, this.endDateLine) > 365) {
      this.requiredMsg2 = '';
      this.lineChartData = [];
      this.lineChartLabels = [];
      this.showMessage = this.const_msg1
    }
    else {
      this.requiredMsg2 = '';
      const refObj: any = {};
      this.lineChartLabels = [];
      this.lineChartData = [];
      let data1;
      this.ngxUiLoaderService.startLoader('loader-04');
      this.kpiService
        .getLineGraph(
          this.selectedEventLine,
          this.selectedDomicileLine.label,
          this.datePipe.transform(this.startDateLine, this.const_date),
          this.datePipe.transform(this.endDateLine, this.const_date),
          this.selectedSpan
        )
        ?.subscribe((res) => { // NOSONAR
          this.ngxUiLoaderService.stopLoader('loader-04');
          this.lineData = res;
          if (this.lineData.length == 0) { // NOSONAR
            this.showMessage = this.const_nodata;
          }
          const stDate = new Date(this.startDateLine);
          const eDate = new Date(this.endDateLine);

          const newLineLabels = [];
          let interval = 0;
          if (this.selectedSpan == 'Daily') { // NOSONAR
            interval = 1;
          } else if (this.selectedSpan == 'Weekly') { // NOSONAR
            interval = 7;
          } else if (this.selectedSpan == 'Monthly') { // NOSONAR
            interval = 30;
          } else {
            interval = 365;
          }
          if (interval == 30) { // NOSONAR
            let stmDate = DateTime.fromFormat(this.startDateLine, this.const_year_format, { zone: 'UTC' });
            const emDate = DateTime.fromFormat(this.endDateLine, this.const_year_format, { zone: 'UTC' });
            while (stmDate.toMillis() <= emDate.toMillis()) {
              let str = stmDate.toFormat(this.const_date);
              this.lineChartLabels.push(
                str
              );
              stmDate = stmDate.endOf('month');
              str = str + ' - ' + stmDate.toFormat(this.const_date);
              newLineLabels.push(stmDate.toFormat("MMM yyyy"));
              stmDate = stmDate.plus({ day: 1 });
            }
            console.info(this.lineChartLabels, newLineLabels);
          } else {
            while (stDate.getTime() <= eDate.getTime()) {
              let str = this.datePipe.transform(stDate.toUTCString(), this.const_date, 'UTC');
              this.lineChartLabels.push(
                str
              );
              stDate.setDate(stDate.getDate() + interval - 1);
              str = str + ' - ' + this.datePipe.transform(stDate.toUTCString(), this.const_date, 'UTC');
              newLineLabels.push(str);
              stDate.setDate(stDate.getDate() + 1);
            }
          }

          this.lineData.forEach((element) => {
            const { eventType, timePeriod, count } = element;
            refObj[eventType] = refObj[eventType] || [];
            refObj[eventType].push({ timePeriod, count });
          });

          let j = 0;

          for (const eType in refObj) {
            data1 = [];

            for (const date of this.lineChartLabels) {
              if (interval == 1) { // NOSONAR
                const foundItem = refObj[eType].find(
                  (item) => item.timePeriod == date // NOSONAR
                );
                if (foundItem) {
                  ;
                  data1.push(foundItem.count);
                } else {

                  data1.push(0);
                }
              } else if (interval == 30) { // NOSONAR
                let from = DateTime.fromFormat(date, this.const_date, { zone: 'UTC' });
                const to = DateTime.fromFormat(date, this.const_date, { zone: 'UTC' }).endOf('month');
                let count = 0;
                while (from.toMillis() <= to.toMillis()) {
                  const xDate = from.toFormat(this.const_date);
                  const foundItem = refObj[eType].find(
                    (item) => item.timePeriod == xDate  // NOSONAR
                  );
                  if (foundItem) {
                    count = count + foundItem.count;
                  }
                  from = from.plus({ day: 1 });
                }
                data1.push(count);
              } else {
                const from = new Date(date);
                const to = new Date(date);
                to.setDate(to.getDate() + interval - 1);
                let count = 0;
                while (from.getTime() <= to.getTime()) {
                  const xDate = this.datePipe.transform(
                    from.toUTCString(),
                    this.const_date,
                    'UTC'
                  );
                  const foundItem = refObj[eType].find(
                    (item) => item.timePeriod == xDate  // NOSONAR
                  );
                  if (foundItem) {
                    count = count + foundItem.count;
                  }
                  from.setDate(from.getDate() + 1);
                }
                data1.push(count);
              }
            }
            const graphData = {
              data: data1,
              label: eType,
              fill: false,
              borderColor: this.borderColors[j],
              backgroundColor: this.borderColors[j],
            };
            j++;

            this.lineChartData.push(graphData);
          }
          if (interval > 1) {
            this.lineChartLabels = newLineLabels;
          }
        });
    }

  }

  close() {
    this.errorMessage = null;
  }

}
